"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as h } from "../../theme-variant-context.js";
import { vars as a } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: i, size: e = 24 } = _param, c = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const l = h(), r = i !== null && i !== void 0 ? i : l ? a.colors.inverse : a.colors.neutralHigh, { skinName: t } = n();
    return t.match(/^o2-new/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ o("path", {
            fill: r,
            d: "M12 5c2.463 0 4.534 1.76 4.963 4.094 2.784 0 5.037 2.224 5.037 4.953S19.751 19 17 19H7c-2.751 0-5-2.224-5-4.953s2.249-4.953 5-4.953h.073A5.03 5.03 0 0 1 12 5m-8.57 9.042c0 1.94 1.605 3.52 3.57 3.52h10c1.96 0 3.565-1.58 3.565-3.52s-1.604-3.52-3.57-3.52a5.5 5.5 0 0 1-.178.828c-.068.285-.356.5-.676.5-.073 0-.142 0-.215-.036-.357-.11-.571-.5-.498-.97a2.7 2.7 0 0 0 .141-.932v-.18c-.068-1.87-1.64-3.34-3.569-3.34-1.746 0-3.213 1.255-3.533 2.872a5.3 5.3 0 0 1 1.284.611c.32.216.43.685.215 1.006-.215.322-.68.432-1 .216A3.7 3.7 0 0 0 7 10.523c-1.96 0-3.57 1.58-3.57 3.52"
        })
    })) : t.match(/^o2/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ o("path", {
            fill: r,
            d: "M12 5c2.463 0 4.534 1.76 4.963 4.094 2.784 0 5.037 2.224 5.037 4.953S19.751 19 17 19H7c-2.751 0-5-2.224-5-4.953s2.249-4.953 5-4.953h.073A5.03 5.03 0 0 1 12 5m-8.57 9.042c0 1.94 1.605 3.52 3.57 3.52h10c1.96 0 3.565-1.58 3.565-3.52s-1.604-3.52-3.57-3.52a5.5 5.5 0 0 1-.178.828c-.068.285-.356.5-.676.5-.073 0-.142 0-.215-.036-.357-.11-.571-.5-.498-.97a2.7 2.7 0 0 0 .141-.932v-.18c-.068-1.87-1.64-3.34-3.569-3.34-1.746 0-3.213 1.255-3.533 2.872a5.3 5.3 0 0 1 1.284.611c.32.216.43.685.215 1.006-.215.322-.68.432-1 .216A3.7 3.7 0 0 0 7 10.523c-1.96 0-3.57 1.58-3.57 3.52"
        })
    })) : /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ o("path", {
            fill: r,
            d: "M6.208 18.966h10.42c2.874 0 5.219-2.334 5.219-5.21A5.22 5.22 0 0 0 16.63 8.54h-.059a6.22 6.22 0 0 0-5.594-3.51c-1.658 0-3.165.636-4.238 1.793-1.005 1.08-1.58 2.563-1.633 4.19a4.24 4.24 0 0 0-2.045 1.395 3.95 3.95 0 0 0-.907 2.504 4.06 4.06 0 0 0 4.053 4.054M9.048 6.53a4.8 4.8 0 0 1 1.928-.383 5.1 5.1 0 0 1 4.647 3.008l.002.008c.185.468.56.507.712.502q.03-.002.061-.003l.062-.003a4.1 4.1 0 0 1 4.263 4.09 4.1 4.1 0 0 1-4.095 4.095H6.208a2.937 2.937 0 0 1-2.933-2.933c0-.815.359-1.431.656-1.8.409-.505.96-.875 1.552-1.043.61-.17.739-.535.739-.812 0-1.44.473-2.742 1.336-3.672.418-.451.925-.81 1.49-1.054"
        })
    }));
}, p = s;
export { p as default };
